/** @module SiteAdmin/Locale/ActiveAttributeController */
define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/when",
	"csi/heading/BooleanController",
	"csi/locale",
	"csi/state",
	"csi/store/Nodes",
	"csi/widget/MessageDialog",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Search"
], function(array,declare,when,BooleanController,locale,state,Nodes,MessageDialog,xml,Query,Search) {

	/**
	 * Get users who are using the particular locale
	 * @param {string} localeCode
	 * @return {Query}
	 */
	function _getUsersQueryWithLocale(localeCode) {
		return new Query()
		.Node(xml.PROP_TYPE, xml.OP_EQUALS, xml.TYPE_USER)
		.Attr("Active", xml.OP_EQUALS, true)
		.Attr("UserType", xml.OP_EQUALS, "UserType:User")
		.Attr("Locale", xml.OP_EQUALS, localeCode, "Child:Details");
	}
	return declare(BooleanController, {
		/** @property {number} nUsersWithLocale - count of the users who are using the locale being deactivating */
		nUsersWithLocale: 0,

		/**
		* Get the count of users in advance
		*/
		_preAction: function() {
			this.inherited(arguments);

			if (!this._getCheckboxValue()) {
				var self = this;
				var localeCode = this.getParent().$Name;

				var store = new Nodes({
					typeNode: "User",
					filterQuery: _getUsersQueryWithLocale(localeCode)
				});

				var queryOptions = {
					requestParameters: {
						"Operation": store.requestOperationCount
					}
				};

				var dfd = store.query(null, queryOptions).then(function(res) {
					self.nUsersWithLocale = res.total;
				});

				return dfd;
			}

			return true;
		},

		/**
		* Returns a boolean based the set value that determines whether the prompt is display
		*/
		hasToConfirmAction: function() {
			var bDisplay = !this._getCheckboxValue() && !!this.nUsersWithLocale;
			return bDisplay;
		},

		/**
		 * Displays a Warning Prompt
		 * @params {Object} params
		 */
		confirmAction: function(params) {
			if (this.nUsersWithLocale > 0) {
				params = params || {};
				params.materialIcon = MessageDialog.ICON_WARNING;
				params.title = locale.resource("DeactivateLocaleTitle");
				var localeCode = this.getParent().$Name;
				var msg = this.getString("_Confirm", [localeCode, this.nUsersWithLocale, localeCode, state.get("siteLocale")]);
				params.message = msg;
				return this.inherited(arguments);
			}

			return null;
		},

		/**
		 * Update the user's locale
		 */
		_onAction: function(call) {
			if (this.nUsersWithLocale > 0) {
				var localeCode = this.getParent().$Name;
				var q = _getUsersQueryWithLocale(localeCode);
				this.m_writer.changeQuery(q, "", "Child:Details").changeAttribute("Locale", xml.ATTR_STRING, state.get("siteLocale"));
			}
		}
	});
});